import { render } from "./GoogleAuth.vue?vue&type=template&id=a284b298"
import script from "./GoogleAuth.vue?vue&type=script&lang=js"
export * from "./GoogleAuth.vue?vue&type=script&lang=js"

import "./GoogleAuth.vue?vue&type=style&index=0&id=a284b298&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__